import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const isProduction = import.meta.env.MODE === "production";
const enableNonProd = import.meta.env.VITE_SENTRY_ENABLE_NON_PROD === "true";
const isEnabled = Boolean(dsn) && (isProduction || enableNonProd);

export function initSentry(): void {
  if (!isEnabled || !dsn) return;

  const environment = isProduction ? "production" : import.meta.env.DEV ? "local" : "development";

  Sentry.init({
    dsn,
    environment,
    tracesSampleRate: environment === "production" ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: environment === "production" ? 1.0 : 0,
  });
}

export function setSentryUser(userId: string, properties?: Record<string, string>): void {
  if (!isEnabled) return;
  Sentry.setUser({ id: userId, ...properties });
}

export function resetSentryUser(): void {
  if (!isEnabled) return;
  Sentry.setUser(null);
}
